import { Offcanvas } from 'bootstrap'

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core'
import { EnvironmentManagerService } from '@services/environment-manager.service'
import { UiService } from '@services/ui.service'

@Component({
  selector: 'shared-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.css'],
  standalone: false
})
export class RightPanelComponent implements AfterViewInit, OnDestroy {
  @Input() trapFocus = false
  private panel: Offcanvas
  @ViewChild('rightPanel') rightPanel: ElementRef
  @ViewChild('rightComponent') rightComponent: ElementRef

  get bodyComponent() { return this._uiService.rightPanel.component }
  get destroyOnClose() { return this._uiService.rightPanel.destroyOnClose }
  get isMobile() { return this._environmentManager.isMobile }
  get isOpen() { return this._uiService.rightPanel.isOpen }
  get isResponsive() { return this._uiService.rightPanel.isResponsive }
  get shouldShowComponent() { return !this.destroyOnClose || this.isOpen }
  get title() { return this._uiService.rightPanel.title }
  get width() { return this._uiService.rightPanel.width }
  // A focus-trapping drawer must sit above navigation, while remaining below modals.
  get zIndex() { return this.trapFocus ? 'var(--overlay-canvas-index)' : this._uiService.rightPanel.zIndex }

  constructor(private _uiService: UiService, private _environmentManager: EnvironmentManagerService) { }

  ngAfterViewInit(): void {
    this.panel = new Offcanvas(this.rightPanel.nativeElement, { scroll: !this.trapFocus })
    this._uiService.rightPanel.panel = this.panel
    this._uiService.rightPanel.componentRef = this.rightComponent
  }

  ngOnDestroy(): void {
    const panel = this.panel
    const element: HTMLElement = this.rightPanel.nativeElement
    if (!panel) return
    const dispose = () => panel.dispose()
    // Bootstrap owns pending transition callbacks and body scroll restoration.
    // Let an in-flight show/hide finish before disposing its DOM references.
    if (element.classList.contains('showing')) {
      element.addEventListener('hidden.bs.offcanvas', dispose, { once: true })
      element.addEventListener('shown.bs.offcanvas', () => panel.hide(), { once: true })
    } else if (element.classList.contains('hiding')) {
      element.addEventListener('hidden.bs.offcanvas', dispose, { once: true })
    } else if (element.classList.contains('show')) {
      element.addEventListener('hidden.bs.offcanvas', dispose, { once: true })
      panel.hide()
    } else {
      dispose()
    }
    if (this._uiService.rightPanel.panel === panel) {
      this._uiService.rightPanel.panel = null
      this._uiService.rightPanel.componentRef = null
      this._uiService.rightPanel.isOpen = false
    }
  }

  closePanel() {
    this._uiService.closeRightPanel()
  }
}